<template>
  <div class="block-wrapper">
    <div class="block-header">
      <h1 class="text-primary font-weight-bold fz-14 mb-0 cursor-pointer" @click="dropItems">
        Danh sách sản phẩm
        <i class="fa fa-chevron-down mx-1" v-if="clickDropItem"></i>
        <i class="fa fa-chevron-up mx-1" v-else></i>
      </h1>
      <div class="btn-list">
        <el-popover placement="top" width="430" trigger="click">
          <div class="d-flex justify-content-end">
            <treeSelect :beforeClearAll="removeSearchItemByCate" class="mr-2 w-100" :multiple="true" :options="listCategory" noResultsText="Không tìm thấy"
              noOptionsText="Chưa có dữ liệu" placeholder="Loại sản phẩm" openDirection="bottom"
              v-model="selectCategory" />
            <el-button type="primary" size="small" @click="searchItemByCate">Áp dụng</el-button>
          </div>
          <el-button slot="reference" size="small" @click="getListCategory(paramListCategory)" class="filter" :class="selectCategory != '' ? 'filter-active' : ''">
            <i class='bx bx-filter-alt fz-20'></i>
          </el-button>
        </el-popover>

        <i @click="currentPage > 1 ? currentPage -= 1 : 1"
          class=" dripicons-chevron-left fz-20 text-bold pt-1 point icon-pgn"
          :class="currentPage === 1 ? 'disabled' : ''" />
        <i @click="currentPage < maxPage ? currentPage += 1 : 1"
          class=" dripicons-chevron-right fz-20 text-bold pt-1 point icon-pgn"
          :class="currentPage === maxPage ? 'disabled' : ''" />
      </div>
    </div>
    <!-- Items -->
    <div v-loading="loadingItem" class="content-wrapper items relative" :class="clickDropItem ? 'active' : ''">
      <template v-if="paginatedProducts.length">
        <div class="block-content" v-for="(item, index) in paginatedProducts" :key="index">
          <div class="block-item h-100" :class="countSelectedItem(item) ? 'block-item-act' : ''" @click="chooseItem(item)">
            <div>
              <span class="item-img"><img :src="(item.images && item.images[0]) || defaultImg" /></span>
            </div>
            <div>
              <el-tooltip v-if="item.name.length > 68" :content="item.name" placement="top" effect="light">
                <h1 class="item-name">{{ item.name }}</h1>
              </el-tooltip>
              <h1 v-else class="item-name">{{ item.name }}</h1>
              <span class="item-price">{{ formatMoneyVND(item.priceMin) }}</span>
              <span v-if="datas.enableInventory">
                <span class="item-quantity" v-if="item.stockQuantity > 0">SL: {{ item.stockQuantity }} {{ (item.unit) ?
                    item.unit.name : ''
                }}</span>
                <span class="item-quantity text-danger" v-else> Hết hàng</span>
              </span>
            </div>
            <el-button type="text"><i class="bx bx-plus text-primary fz-20"></i></el-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="h4 text-secondary text-center w-100 mt-1">Không tìm thấy sản phẩm nào.</div>
      </template>
    </div>
    <!-- Variants -->
    <el-dialog append-to-body title="Chọn biến thể sản phẩm" :visible.sync="openSelectVariations" class="boxVariation">
      <div class="scrollItemVari">
        <div class="item-variations-content py-2" v-for="(variation, index) in selectVariations.variations" :key="index"
        @click="chooseVariationItem(variation, selectVariations.itemId, selectVariations.useImeiAndSerial, selectVariations.useProductBatch)"
        :class="countSelectedVariation(variation) ? 'item-variations-content-act' : ''">
        <div class="ivc-image">
          <span><img :src="(variation.images && variation.images[0]) || defaultImg" /></span>
        </div>
        <div class="ivc-value">
          <p class="item-name item-name-ext">{{ variation.name }}</p>
          <div>
            <p class="item-price text-right mb-0">{{ formatMoneyVND(variation.prices[0].amount) }}</p>
            <div v-if="datas.enableInventory">
              <p class="item-quantity text-right mb-0" v-if="variation.stockQuantity > 0">SL: {{ variation.stockQuantity
              }} {{ (variation.unit) ? variation.unit.name : '' }}</p>
              <p class="item-quantity text-right text-danger mb-0" v-else> Hết hàng</p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </el-dialog>
    <!--Điều hướng bật cấu hình bán âm-->
    <b-modal v-if="modalActiveNegativeInv" v-model="modalActiveNegativeInv" size="md" centered hide-header hide-footer no-close-on-backdrop id="modalActiveNegativeInv">
      <div class="head-popup-payment-method mb-0">
        <button type="button" aria-label="Close" class="close close-ext font-weight-light" @click="modalActiveNegativeInv=false">×</button>
        <div class="text-title-modal text-bold fz-18">Sản phẩm đã hết hàng</div>
      </div>
      <div class="content-popup-dilivery-method">
          <div class="text-center">
            <img src="@/assets/images/box-decline.svg" />
          </div>
          <div class="mt-2 boxNoteNegativeInv">
            Sản phẩm bạn vừa chọn đã hết hàng. Để được bán âm sản phẩm, vui lòng đi đến <a href="javascript:void(0)" @click="configActiveNegativeInv">Cấu hình bán hàng</a>
          </div>
          <div class="mt-4 text-right bd-line-top-button">
            <el-button class="btn-default btn-default-ext" @click="modalActiveNegativeInv=false">Đóng</el-button>
            <el-button type="primary" @click="configActiveNegativeInv">Đi đến cấu hình</el-button>
          </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapMutations, mapGetters, createLogger } from "vuex"
import { defaultImg, showMess, popupAllowedMinus } from "../utils/pos"
import { ProductService } from "@/services/nextshop/product.service"
import getStockQuantityVariNum from "../mixins/pos"
import returnStockQuantityVari from "../mixins/pos"
import addVariForListCart from "../mixins/pos"
import "@riophae/vue-treeselect/dist/vue-treeselect.css"
import treeSelect from "@riophae/vue-treeselect"
import { CategoryService } from "@/services/nextshop/category.service"



export default {
  name: "Item",
  props: {
    datas: {
      type: Object,
      default: () => {return {}}
    }
  },
  mixins: [
    getStockQuantityVariNum,
    returnStockQuantityVari,
    addVariForListCart
  ],
  components: {
    treeSelect
  },
  data() {
    return {
      defaultImg: defaultImg,
      clickDropItem: true,
      listItem: [],
      listItemShow: [],
      listCategory: [],
      selectCategory: [],
      paramListCategory: {
        queryString: { parentId: { ne: "" } },
        sort: "-id",
        lastItem: "",
        limit: 100,
      },
      maxPage: 0,
      perPage: 6,
      currentPage: 1,
      params: {
        queryString: '',
        pagingAndSorting: {
          limit: 500,
          lastIndex: "",
          sortOrder: "DESC",
        },
      },
      openSelectVariations: false,
      selectVariations: [],
      modalActiveNegativeInv: false,
      loadingItem: false,
    }
  },
  async created() {
    try {
      this.getListProduct(this.params)
    } catch (error) {
      console.log(error)
    }
  },
  computed: {
    ...mapGetters("sell", ["getRmId"]),
    paginatedProducts() {
      const { currentPage, perPage } = this;
      const start = (currentPage - 1) * perPage;
      const end = currentPage * perPage;
      return this.listItemShow.slice(start, end);
    },
    itemPos:{
      get() {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1
        if(index == -1){
          index = 0
          this.SET_RM_ID(index)
        }
        return this.datas.orders[index]
      },
      set(newValue) {
        let index = this.datas.orders.length > 0 ? this.datas.orders.findIndex((item) => item.rm_id == this.getRmId) : -1
        if(index == -1){
          index = 0
          this.SET_RM_ID(index)
        }
        this.datas.orders[index] = newValue
      }
    }
  },
  methods: {
    ...mapMutations("sell", ["SET_RM_ID", "SET_LOADING"]),
    async searchItemByCate() {
      if (this.selectCategory.length > 0) {
        this.params.queryString = `{category.categoryId}in['''${this.selectCategory.join("''', '''")}''']`
        this.listItemShow = await this.getListProductApi(this.params)
        // console.log(this.params.queryString);
        // console.log(33, this.listItemShow);
        this.maxPageShow = Math.ceil(this.listItemShow.length / this.perPage)
        this.clickDropItem = true
      } else {
        this.listItemShow = this.listItem
        this.maxPageShow = this.maxPage
      }
    },
    removeSearchItemByCate() {
      this.selectCategory = []
      this.searchItemByCate()
    },
    async getListCategory(params) {
      if(this.listCategory.length > 0) return
      try {
        const response = await CategoryService.getList(params)
        this.listCategory = response.data.map((e) => {
          return {
            id: e.id,
            label: e.name,
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    dropItems() {
      this.clickDropItem = !this.clickDropItem
    },
    async getListProductApi(param) {
      this.loadingItem = true
      const listItem = []
      try {
        const response = await ProductService.getList(param)
        const dataRes = response.data
        if (response.status === 200) {
          dataRes.map((e) => {
            const arrVariations = e.variations
            //Check Emei/Serial
            e.useImeiAndSerial = (e.metaSearchable.useImeiAndSerial == "true") ? true : false
            e.useProductBatch = (e.metaSearchable.useProductBatch == "true") ? true : false

            e = this.getStockQuantityVariNum(e)

            let arrPricesVariation = []
            arrVariations.map((variation) => {

              variation = this.returnStockQuantityVari(variation)
              if (variation.prices.length > 0) {
                variation.prices[0].amount = this.dissociationThousand(
                  variation.prices[0].amount
                )
                if (variation.prices[1]) {
                  variation.prices[1].amount = this.dissociationThousand(
                    variation.prices[1].amount
                  )
                }
              }
              variation.unit = e.unit.name

              if (variation.prices.length > 0) {
                variation.prices.map((vl, idx) => {
                  if (vl.priceTypeCode === 'PRICE_EXPORT') {
                    arrPricesVariation.push(variation.prices[idx].amount)
                  }
                })
              } else {
                arrPricesVariation.push(0)
              }

              const checkImagesVari = variation.images.filter(e => e != "")
              const checkImagesItem = e.images.filter(v => v != "")
              variation.images = checkImagesVari
              if(checkImagesVari.length == 0 && checkImagesItem.length > 0){
                variation.images = e.images
              }

            })

            listItem.push({
              ...e,
              priceMin: Math.min(...arrPricesVariation),
              priceMax: Math.max(...arrPricesVariation),
              unit: e.unit.name
            })
          })
        }
        return listItem
      } catch (error) {
        console.log(error)
        return listItem
      } finally {
        this.loadingItem = false

      }
    },
    async getListProduct(param) {
      this.listItem = await this.getListProductApi(param)
      this.maxPage = Math.ceil(this.listItem.length / this.perPage)
      this.listItemShow = this.listItem
    },
    countSelectedItem(item) {
      const result = this.itemPos.listItemCart.filter((e) => e.lineItemId === item.itemId)
      return result.length > 0 ? result.reduce((a, b) => a + b.quantity, 0) : null
    },
    countSelectedVariation(variation) {
      const resul = this.itemPos.listItemCart.filter((e) => e.itemInstance && e.itemInstance.itemVariationId === variation.variationId)
      return resul.length > 0 ? resul.reduce((a, b) => a + b.quantity, 0) : null
    },
    chooseItem(item) {
      if (item.options.length > 0) {
        this.selectVariations = item;
        this.openSelectVariations = true
      } else {
        this.chooseVariationItem(item.variations[0], item.itemId, item.useImeiAndSerial, item.useProductBatch)
      }
    },
    async chooseVariationItem(variation, idItem, useImeiAndSerial, useProductBatch) {
      this.SET_LOADING(true)
     
      const index = this.itemPos.listItemCart.length > 0
          ? this.itemPos.listItemCart.findIndex((e) => e.itemInstance && (e.itemInstance.itemVariationId === variation.variationId || e.itemInstance.itemVariationId === variation._itemVariationId) && e.lineItemId === idItem)
          : -1
      const result = await this.addVariForListCart(variation, idItem, useImeiAndSerial, useProductBatch)
      
      this.SET_LOADING(false)
     
      if (this.itemPos.listItemCart.length === 0 || index === -1) {
        if (variation.stockQuantity == 0) {
          if (!useImeiAndSerial && !useProductBatch) {
            if (this.datas.enableInventory !== false) {
              if(this.datas.activeNegativeInv){
                const resPopup = popupAllowedMinus()
                resPopup.then((_result) => {
                  if (_result.value) {
                    this.itemPos.listItemCart.push(result)
                    this.caculateMoneyPos(this.itemPos)
                    showMess(this, 'Thông báo', 'Thêm sản phẩm vào đơn thành công!', 'success', 'b-toaster-top-right', 1000)
                    return false
                  }
                })
              }else{
                this.modalActiveNegativeInv = true
                return false
              }
            } else {
              this.itemPos.listItemCart.push(result)
              this.caculateMoneyPos(this.itemPos)
              showMess(this, 'Thông báo', 'Thêm sản phẩm vào đơn thành công!', 'success', 'b-toaster-top-right', 1000)
              return false
            }
          } else {
            if (useImeiAndSerial) {
              showMess(this, 'Thông báo', 'Sản phẩm không được bán vượt quá số tồn kho.Vui lòng nhập kho EMEI/se-ri cho sản phẩm này.', 'danger', 'b-toaster-top-right', 1000)
              return false
            }
            if (useProductBatch) {
              showMess(this, 'Thông báo', 'Sản phẩm không được bán vượt quá số tồn kho. Vui lòng nhập kho Lô cho sản phẩm này.', 'danger', 'b-toaster-top-right', 1000)
              return false
            }
            return false
          }
        } else {
          this.itemPos.listItemCart.push(result)
          this.caculateMoneyPos(this.itemPos)
          showMess(this, 'Thông báo', 'Thêm sản phẩm vào đơn thành công!', 'success', 'b-toaster-top-right', 1000)
          return false
        }
      } else {
        if (index != -1) {
          this.itemPos = this.increasePos(this.itemPos, index)
          if (this.itemPos.listItemCart[index]) {
            this.caculateMoneyPosItem(this.itemPos.listItemCart[index])
          }
          this.caculateMoneyPos(this.itemPos)
          return false
        }
      }
      return true
    },
    configActiveNegativeInv(){
      this.$router.push('/setting/config')
    }
  },
}
</script>

<style lang="scss" scoped>
.block-wrapper {
  width: 100%;
  border-radius: 4px 4px 0px 0px;
  margin-top: 10px;

  .block-header {
    position: relative;
    width: calc(100% + 30px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: -15px;
    padding: 12px 15px;
    border-top: 1px solid #DDDDDD;
    border-bottom: 1px solid #DDDDDD;
  }

  .btn-list {
    display: flex;
    align-items: center;

    i:not(:last-child) {
      margin-left: 20px;
      margin-right: 20px;
    }

    i.icon-pgn {
      color: #495057;
    }

    i.icon-pgn.disabled {
      color: #BDC1C5;
    }
  }

  .content-wrapper {
    background-color: white;
    display: flex;
    flex-wrap: wrap;
    padding-top: 10px;
    justify-content: flex-start;
    margin-left: -4px;
    margin-right: -4px;
    .block-content {
      width: 32.2%;
      min-width: 32.2%;
      margin: 6px 4px;

      .block-item {
        position: relative;
        box-shadow: 0px 10px 24px rgba(18, 38, 63, 0.05);        border-radius: 4px;
        padding: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        .item-img {
          display: block;
          width: 40px;
          height: 40px;
          border-radius: 4px;
          margin-right: 20px;

          img {
            display: inline-block;
          }
        }

        .item-name {
          font-size: 14px;
          line-height: 22px;
          margin-bottom: 4px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;  
          overflow: hidden;
          margin-right: 21px;
        }

        .item-price {
          font-size: 12px;
          line-height: 20px;
          color: #3E69F6;
          margin-right: 20px;
        }

        .item-quantity {
          font-size: 10px;
          line-height: 16px;
          color: #808890;
        }

        button {
          position: absolute;
          right: 13px;
        }
      }
    }
  }
}

.item-variations-content {
  width: 100%;
  display: flex;
  cursor: pointer;

  &:not(:first-child),
  &:not(:last-child) {
    box-shadow: inset 0px -1px 0px #E4E4E4;
  }

  ::v-deep .ivc-image {
    display: inline-block;
    margin-right: 15px;
    width: 40px;
    height: 40px;
  }

  .ivc-value {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

::v-deep .ivc-value .item-price {
  color: #3E69F6;
  font-size: 14px;
}

::v-deep .ivc-value .item-quantity {
  color: #808890;
  font-size: 10px;
}

::v-deep .ivc-value .item-price {
  max-width: 400px;
}

::v-deep .filter {
  border: none;
  background: none;
  color: #000;
  padding: 0;
}

.filter-active {
  position: relative;

  &::after {
    position: absolute;
    content: '';
    top: -1px;
    right: -2px;
    width: 6px;
    height: 6px;
    background: #DC2323;
    border-radius: 50%;
  }
}

.disabled {
  color: #BDC1C5
}

.font-size-25 {
  font-size: 25px !important;
}

.point {
  cursor: pointer;
}

.block-item {
  border: 1px solid #fff;
}

.block-item:hover {
  border: 1px solid #ddd;
}

.block-item-act {
  border: 1px solid #ddd;
}

.item-variations-content-act {
  font-weight: bold;
  color: #000
}

.item-name-ext {
  width: 85%;
  word-break: normal;
}
.scrollItemVari {
  height: 350px;
  width: 100%;
  overflow-x: hidden;
  padding-right: 2px;
  display: inline-block;
}
</style>